
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pm",
      function () {
        return require("private-next-pages/pm.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pm"])
      });
    }
  